var map = {
	"./aaaaaa.png": 61979,
	"./aaaaaaa.png": 90394,
	"./aaaaaaaa-mts.png": 90872,
	"./af-mechatronics.png": 56671,
	"./mts1.png": 36918,
	"./mts2.png": 50893,
	"./mts3.png": 96996,
	"./mts4.png": 60859,
	"./mts5.png": 46034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47586;